<div class="wrap top">
  <div>
    <div class="venue">
      <img *ngIf="restaurant.logo" [src]="restaurant.logo" alt="" />
      <div>
        <b>{{ restaurant | titleTranslate }}</b>
        <span *ngIf="restaurant.description">{{ restaurant.description }}</span>
      </div>
    </div>
    <button class="link" *ngIf="showContacts" (click)="contacts.emit()">{{ 'contactsAndDetails' | translate }}</button>
    <button class="link" (click)="copyLink.emit()">{{ (linkCopied ? 'linkCopied' : 'copyLink') | translate }}</button>
  </div>

  <div class="column">
    <h4>{{ 'ctaTitle' | translate }}</h4>
    <p>{{ 'ctaText' | translate }}</p>
    <!-- В одном стиле с кнопками магазинов; ведёт на регистрацию в веб-версии -->
    <a class="badge" [href]="signUpUrl" target="_blank" rel="noopener">
      <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="9" /><path d="M3 12h18M12 3c2.5 2.6 3.8 5.6 3.8 9s-1.3 6.4-3.8 9c-2.5-2.6-3.8-5.6-3.8-9S9.5 5.6 12 3z" /></svg>
      <span><small>{{ 'openInBrowser' | translate }}</small><b class="muted">Edim app</b></span>
    </a>
  </div>

  <div class="column">
    <h4>{{ 'edimApp' | translate }}</h4>
    <p>{{ 'edimAppText' | translate }}</p>
    <div class="stores">
      <a class="badge" [attr.href]="appStoreUrl" [class.soon]="!appStoreUrl" target="_blank" rel="noopener"
        [attr.title]="appStoreUrl ? null : ('soon' | translate)">
        <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor"><path d="M16.4 12.6c0-2.4 2-3.6 2.1-3.7-1.1-1.7-2.9-1.9-3.5-1.9-1.5-.2-2.9.9-3.7.9-.8 0-1.9-.9-3.2-.8-1.6 0-3.1 1-4 2.4-1.7 3-.4 7.4 1.2 9.8.8 1.2 1.8 2.5 3 2.4 1.2 0 1.7-.8 3.1-.8 1.5 0 1.9.8 3.2.8 1.3 0 2.2-1.2 3-2.4.9-1.4 1.3-2.7 1.3-2.8 0 0-2.5-1-2.5-3.9zM14 5.5c.7-.8 1.1-1.9 1-3-1 0-2.1.7-2.8 1.5-.6.7-1.2 1.8-1 2.9 1.1.1 2.1-.6 2.8-1.4z" /></svg>
        <span><small>{{ (appStoreUrl ? 'downloadOn' : 'soon') | translate }}</small><b>App Store</b></span>
      </a>
      <a class="badge" [attr.href]="googlePlayUrl" [class.soon]="!googlePlayUrl" target="_blank" rel="noopener"
        [attr.title]="googlePlayUrl ? null : ('soon' | translate)">
        <svg viewBox="0 0 24 24" width="20" height="20"><path d="M4 2.8 13.6 12 4 21.2c-.3-.2-.5-.6-.5-1V3.8c0-.4.2-.8.5-1z" fill="#00D3FF" /><path d="m16.8 8.8-3.2 3.2L4 2.8c.1 0 .3-.1.5-.1.2 0 .4.1.6.2l11.7 5.9z" fill="#00F076" /><path d="M16.8 15.2 5.1 21.1c-.2.1-.4.2-.6.2-.2 0-.4 0-.5-.1l9.6-9.2 3.2 3.2z" fill="#FF3A44" /><path d="m20.4 12.9-3.6 2.3-3.2-3.2 3.2-3.2 3.6 2.3c.8.5.8 1.3 0 1.8z" fill="#FFD500" /></svg>
        <span><small>{{ (googlePlayUrl ? 'getItOn' : 'soon') | translate }}</small><b>Google Play</b></span>
      </a>
    </div>
  </div>
</div>

<div class="bottom">
  <div class="wrap">
    <label class="select" *ngIf="languages.length > 1">
      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 5h9M8.5 3v2M6 5c.8 3.5 3 6 6 7.5M11 5c-.8 3.5-3 6-6 7.5" /><path d="m12 21 4.5-10 4.5 10M13.6 17.5h5.8" /></svg>
      <select [value]="language" (change)="languageChange.emit($any($event.target).value)">
        <option *ngFor="let lang of languages" [value]="lang" [selected]="lang === language">{{ names[lang] || lang }}</option>
      </select>
    </label>
    <span class="spacer"></span>
    <span>© {{ year }} Edim</span>
    <a [href]="policyUrl" target="_blank" rel="noopener">{{ 'privacyPolicy' | translate }}</a>
  </div>
</div>
